/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
export function isNonNullObject(obj) {
    return obj !== null && typeof obj === "object";
}
//# sourceMappingURL=isNonNullObject.js.map
